import { CircularProgress, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function NewsFeedLoadingMoreState() {
  return (
    <Stack spacing={2} justifyContent="center" alignItems="center">
      <CircularProgress />
      <Text>Loading more news...</Text>
    </Stack>
  );
}
